import React, { createContext, useState } from "react";
import axios from "axios";
import { ApiConfig } from "config/ApiConfig";
import { toast } from "react-toastify";
import DynamicModal from "components/Widgets/DynamicModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { ShowToastError } from "components/Widgets/ShowToastError";

const PaymentContext = createContext();

const PaymentProvider = ({ children }) => {
  // Trail Modal States
  const [showModalTrail, setShowModalTrail] = useState(false);
  const [showModalTrailConfirm, setShowModalTrailConfirm] = useState(false);
  const [isLoadingTrail, setIsLoadingTrail] = useState(false);

  // Features and Billing
  const [features, setFeatures] = useState([]);
  const [billingCycle, setBillingCycle] = useState("month");
  const [allowedScreens, setAllowedScreens] = useState(
    JSON.parse(sessionStorage.getItem("topCXDataAdmin"))?.topCXAllowedScreens ||
      {}
  );

  // Start Trail API
  const startTrail = async () => {
    const purchase_order = features.map((feature) => {
      const transformedFeature = {
        id: feature.id,
        quantity: feature.currentLicenses,
        subItems: [],
      };

      // Add subItems if config exists, using their IDs
      if (feature.config && feature.config.length > 0) {
        transformedFeature.subItems = feature.config.map((cfg) => ({
          id: cfg.id,
          quantity: cfg.currentCount,
        }));
      }

      return transformedFeature;
    });

    const config = {
      headers: { "Access-Control-Allow-Origin": "*" },
      withCredentials: true,
    };

    const apiData = {
      purchaseOrder: purchase_order,
      planFrequency: billingCycle,
    };

    try {
      setIsLoadingTrail(true);
      const response = await axios.post(ApiConfig.startTrail, apiData, config);

      const existingData =
        JSON.parse(sessionStorage.getItem("topCXDataAdmin")) || {};
      sessionStorage.setItem(
        "topCXDataAdmin",
        JSON.stringify({
          ...existingData,
          topCXAllowedScreens: response?.data?.allowedScreens,
        })
      );
      setAllowedScreens(response?.data?.allowedScreens);
      toast.success("Trial started successfully!");
    } catch (error) {
      ShowToastError({ error });
    } finally {
      setIsLoadingTrail(false);
      setShowModalTrailConfirm(false);
      setShowModalTrail(false);
    }
  };

  // Confirm Trail Modal
  const ConfirmTrailModal = (
    <DynamicModal
      title="Confirm Trial"
      show={showModalTrailConfirm}
      onHide={() => setShowModalTrailConfirm(false)}
      size="lg"
    >
      <div className="p-4">
        <div className="d-flex align-items-center mb-3">
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className="me-2"
            style={{ color: "#Ac5A2B", fontSize: "16px" }}
          />
          <h6 style={{ color: "#Ac5A2B", fontSize: "15px" }}>
            Confirm 15-day trial activation
          </h6>
        </div>
        <p>Your trial will start immediately and last for 15 days.</p>
        <div className="d-flex justify-content-end mt-4">
          <button
            className="btn btn-secondary me-2"
            onClick={() => setShowModalTrailConfirm(false)}
            style={{
              height: "30px",
              width: "80px",
              fontSize: "12px",
            }}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={startTrail}
            disabled={isLoadingTrail}
            style={{
              height: "30px",
              width: "80px",
              fontSize: "12px",
            }}
          >
            {isLoadingTrail ? "Starting..." : "Confirm"}
          </button>
        </div>
      </div>
    </DynamicModal>
  );

  return (
    <PaymentContext.Provider
      value={{
        startTrail,
        showModalTrail,
        setShowModalTrail,
        showModalTrailConfirm,
        setShowModalTrailConfirm,
        isLoadingTrail,
        features,
        setFeatures,
        billingCycle,
        setBillingCycle,
        allowedScreens,
        ConfirmTrailModal,
      }}
    >
      {children}
    </PaymentContext.Provider>
  );
};

export { PaymentContext, PaymentProvider };
